/**
 * The run's status line: the floor number, the leader's name, HP and AP over
 * their maxima, each a template of the string table
 * (`ui.status.floor` is "{floor}", filled with the floor's name by the
 * dungeon's direction, `ui.floor.down` "B{floor}F" or `ui.floor.up`, ADR
 * 0032; the word order is the locale's). The
 * maxima come from game-core's `unitStat` with the content pack; the
 * component computes nothing itself. The graphics tier left the line in
 * slice 6b: it is a row of the pause menu.
 */
import type { ContentPack } from '@ab/content-schema';
import { type RunState, unitStat } from '@ab/game-core';
import { type Strings, createNamer, floorName } from '@ab/session';
import { formatText } from './text.ts';
import './ui.css';

export type RunStatusProps = {
  readonly state: RunState;
  readonly content: ContentPack;
  readonly strings: Strings;
};

export const RunStatus = ({ state, content, strings }: RunStatusProps) => {
  const leader = state.units.find((u) => u.id === state.party[0]);
  return (
    <section className="ab-status" data-testid="run-status">
      <span>{formatText(strings, 'ui.status.floor', { keys: { floor: floorName(content.dungeons[state.dungeon]?.direction ?? 'down', state.floorNumber) } })}</span>
      {leader && (
        <>
          <span>{createNamer(strings, [state]).unit(leader.id)}</span>
          <span>{formatText(strings, 'ui.status.hp', { values: { hp: leader.hp, max: unitStat(content, leader, 'hp') } })}</span>
          <span>{formatText(strings, 'ui.status.ap', { values: { ap: leader.ap, max: unitStat(content, leader, 'ap') } })}</span>
        </>
      )}
    </section>
  );
};
